import { c as _c } from "react/compiler-runtime";
import { useDropdown } from "@website/ui/dropdown/dropdown.hook";
import styles from "@website/ui/dropdown/dropdown.module.scss";
import { DropdownPropertiesType } from "@website/ui/dropdown/dropdown.types";
import { Menu } from "@website/ui/menu";
import { MiniPopover } from "@website/ui/mini-popover";
import { TextField } from "@website/ui/text-field";
import { FC } from "react";
export const Dropdown: FC<DropdownPropertiesType> = properties => {
  const $ = _c(16);
  const {
    className,
    disabled,
    error,
    fullWidth,
    inputMode,
    menuClassName,
    otherPopoverProperties: t0
  } = properties;
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const otherPopoverProperties = t1;
  const {
    textfieldProps,
    popoverProps,
    menuProps
  } = useDropdown(properties);
  const t2 = `${styles.dropdown} ${error ? styles.error : ""} ${disabled ? styles.disabled : ""} ${fullWidth ? styles.fullWidth : ""} ${className ?? ""}`;
  const t3 = `${className} ${styles["text-field"]}`;
  let t4;
  if ($[2] !== inputMode || $[3] !== t3 || $[4] !== textfieldProps) {
    t4 = <TextField className={t3} inputMode={inputMode} {...textfieldProps} />;
    $[2] = inputMode;
    $[3] = t3;
    $[4] = textfieldProps;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== disabled || $[7] !== menuClassName || $[8] !== menuProps || $[9] !== otherPopoverProperties || $[10] !== popoverProps) {
    t5 = disabled ? null : <MiniPopover {...popoverProps} {...otherPopoverProperties}><div className={styles.popover}><Menu {...menuProps} className={menuClassName} /></div></MiniPopover>;
    $[6] = disabled;
    $[7] = menuClassName;
    $[8] = menuProps;
    $[9] = otherPopoverProperties;
    $[10] = popoverProps;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div className={t2}>{t4}{t5}</div>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};